import React, { useState, useEffect } from 'react';
// Remove AuthContext if not directly needed here, user info comes via API
// import { AuthContext } from '../../AuthContext';
import AppPaginator from '../../AppPaginator';
import { destroyParty, destroyPartiesMultiple, fetchParty, getParties } from '../../../api/PartiesAPI';
import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import AppSearchBox from '../../AppSearchBox';// Adjust path as needed
// import PartiesReport from './PartiesReport'; // Create this component if needed
import { useLocation, useNavigate } from 'react-router-dom';
import AppBreadCrumb from '../../common/AppBreadCrumb'; // Adjust path as needed
import PerPageBlock from '../../common/PerPageBlock'; // Adjust path as needed
import Swal from 'sweetalert2';
// Assuming getAvatar is a general utility
import { getAvatar } from '../../../commonfunctions'; 


const PartiesPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const successMessage = location.state?.message;

    // const { user } = useContext(AuthContext); // Get user/franchisee data if needed elsewhere

    const [entityName, setEntityName] = useState('Party'); // Changed entity name
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [reportLoading, setReportLoading] = useState(false); // For future report component
    const [viewDataLoading, setViewDataLoading] = useState(false);
    const [searchTermCompleted, setSearchTermCompleted] = useState('');
    const [perPage, setPerPage] = useState(process.env.REACT_APP_PER_PAGE_COUNT || 10);
    const [enableMultipleItemSelect, setEnableMultipleItemSelect] = useState(false);

    const [partiesList, setPartiesList] = useState({ // Renamed state variable
        paginate: true,
        data: [],
        per_page: perPage,
        current_page: 1, // Start at page 1
        tot_page: null,
    });
    const [partyNumbering, setPartyNumbering] = useState('auto'); // Added state for numbering type


    const [toaster, setToaster] = useState({ type: '', heading: '', message: '' });
    const [showToaster, setShowToaster] = useState(false);
    const [saveCompleted, setSaveCompleted] = useState(false); // Used to trigger refresh after save/delete
    // const [viewButtonToggle, setViewButtonToggle] = useState(false); // Removed if not used

    const [selectedPartyIds, setSelectedPartyIds] = useState(new Set()); // Renamed state variable

    // --- Navigation Handlers ---
    const handleAddClick = () => {
        navigate('/franchisee_user/masters/parties/create'); // Updated route
    };

    const handleEditClick = (partyId) => {
        navigate(`/franchisee_user/masters/parties/edit/${partyId}`); // Updated route
    };

    // --- Delete Handlers ---
    const handleDeleteClick = (partyId) => {
        fetchParty(partyId, function (result) { // Use fetchParty
            if (result.party) {
                const deleteParty = result.party;
                Swal.fire({
                    title: 'Are you sure?',
                    html: `
                        <p>You are about to delete the following party:</p>
                        <ul class="delete-details-list">
                            <li class="details-row"><span><strong>Party ID:</strong></span><span>${deleteParty.id}</span></li>
                            <li class="details-row"><span><strong>Party Name:</strong></span><span>${deleteParty.name}</span></li>
                            ${deleteParty.code ? `<li class="details-row"><span><strong>Code:</strong></span><span>${deleteParty.code}</span></li>` : ''}
                        </ul>
                        <p>This action cannot be undone.</p>
                    `,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Yes, delete it!'
                }).then((dialogResult) => {
                    if (dialogResult.isConfirmed) {
                        destroyParty(deleteParty, function (apiResponse) { // Use destroyParty
                            if (apiResponse.party) { // Success indication
                                Swal.fire( 'Deleted!', 'Your record has been deleted.', 'success' );
                                setSaveCompleted(prevState => !prevState); // Trigger data refresh
                            } else if (apiResponse.error?.response?.data?.message) {
                                Swal.fire('Error!', apiResponse.error.response.data.message, 'error');
                            } else {
                                Swal.fire('Error!', 'Could not delete the party.', 'error');
                            }
                        });
                    }
                });
            } else {
                 Swal.fire('Error!', 'Could not fetch party details for deletion.', 'error');
            }
        });
    };

    const showMultipleDeleteConfirmation = () => {
        const deletingParties = partiesList.data.filter(party => selectedPartyIds.has(party.id));

        Swal.fire({
            title: 'Are you sure?',
            html: `
                <p>You are about to delete the following ${deletingParties.length} parties:</p>
                <div style="max-height: 150px; overflow-y: auto;">
                    ${deletingParties.map(party => `
                        <ul class="delete-details-list mb-2">
                            <li class="details-row"><span><strong>ID:</strong></span><span>${party.id}</span></li>
                            <li class="details-row"><span><strong>Name:</strong></span><span>${party.name}</span></li>
                            ${party.code ? `<li class="details-row"><span><strong>Code:</strong></span><span>${party.code}</span></li>` : ''}
                        </ul>
                    `).join('')}
                </div>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, delete them!'
        }).then((result) => {
            if (result.isConfirmed) {
                const idsToDelete = Array.from(selectedPartyIds);
                destroyPartiesMultiple(idsToDelete, function (response) { // Use destroyPartiesMultiple
                    if (response.party) { // Success indication
                        Swal.fire('Deleted!', 'The selected records have been deleted.', 'success');
                        setEnableMultipleItemSelect(false);
                        setSelectedPartyIds(new Set());
                        setSaveCompleted(prevState => !prevState); // Trigger refresh
                    } else if (response.error?.response?.data?.message) {
                        Swal.fire('Error!', response.error.response.data.message, 'error');
                    } else {
                        Swal.fire('Error!', 'Could not delete the selected parties.', 'error');
                    }
                });
            }
        });
    };

    // --- Checkbox Handler ---
    const handleCheckboxChange = (id, isChecked) => {
        setSelectedPartyIds(prevSelectedIds => {
            const newSelectedIds = new Set(prevSelectedIds);
            if (isChecked) {
                newSelectedIds.add(id);
            } else {
                newSelectedIds.delete(id);
            }
            return newSelectedIds;
        });
    };

    // --- Effects ---
    useEffect(() => {
        if (successMessage) {
            setShowToaster(true);
            setToaster({ type: 'success', heading: 'Success', message: successMessage });
             // Clear the message from location state after showing
             navigate(location.pathname, { replace: true, state: {} });
        }
    }, [successMessage, location.pathname, navigate]);

    useEffect(() => {
        document.title = 'Manage Parties'; // Update page title
        let filters = {
            paginate: partiesList.paginate,
            page: currentPage,
            per_page: perPage,
            search_term: searchTermCompleted,
        };

        setViewDataLoading(true);
        setSelectedPartyIds(new Set()); // Clear selection on data reload
        setEnableMultipleItemSelect(false); // Disable multi-select on reload

      getParties(filters, function (response) {
      setViewDataLoading(false);
      // console.log("API Response:", response); // Good for debugging

      // *** CORRECTED LOGIC START ***
      if (response.parties) {
        let partiesData = [];
        let currentPageNum = 1;
        let lastPageNum = 1;
        let responsePerPage = perPage; // Default

        // Check if the response is a paginated object or a simple array
        if (Array.isArray(response.parties)) {
          // It's a simple array (likely from ->get() or empty result)
          partiesData = response.parties;
          // Reset pagination info if we got a simple array
          currentPageNum = 1;
          lastPageNum = 1;
          // We don't know the intended per_page from a simple array response
        } else if (response.parties.data && Array.isArray(response.parties.data)) {
          // It's a paginated object
          partiesData = response.parties.data;
          currentPageNum = response.parties.current_page;
          lastPageNum = response.parties.last_page;
          responsePerPage = response.parties.per_page;
        } else {
           // Unexpected response structure
           console.error("Unexpected API response structure for parties:", response.parties);
           handleApiError(response); // Use your error handler
           setToaster({ type: 'danger', heading: 'Error', message: 'Could not load parties due to unexpected data format.' });
           setShowToaster(true);
           // Keep previous data or reset to empty
            setPartiesList(prev => ({ ...prev, data: [], current_page: 1, tot_page: 1 })); // Reset safely
            setPartyNumbering(response.party_numbering || 'auto');
           return; // Stop further processing
        }

        setPartiesList({
          paginate: filters.paginate, // Keep the requested pagination setting
          per_page: responsePerPage,  // Use per_page from response if available
          data: partiesData,
          current_page: currentPageNum,
          tot_page: lastPageNum,
        });
        setPartyNumbering(response.party_numbering || 'auto');

      } else {
        // Handle API errors where response.parties itself is missing
        handleApiError(response);
        setToaster({ type: 'danger', heading: 'Error', message: 'Could not load parties.' });
        setShowToaster(true);
         // Reset state safely
         setPartiesList(prev => ({ ...prev, data: [], current_page: 1, tot_page: 1 }));
      }
      // *** CORRECTED LOGIC END ***
    });
    }, [currentPage, searchTermCompleted, saveCompleted, perPage]); // Removed viewButtonToggle dependency

    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />

            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title='Parties List'> {/* Updated title */}
                        <li> <a className="f-s-14 f-w-500" href="#">Masters</a> </li>
                        <li className="active"> <a className="f-s-14 f-w-500" href="#">Parties List</a> </li>
                    </AppBreadCrumb>

                    <div className="row bg-white">
                        <div className="col-12">
                            <div className="tab-wrapper mb-3">
                                <ul className="tabs">
                                    <li className="tab-link active" data-tab={1}>All Parties</li>
                                    <li className="ms-md-auto">
                                        <div className="text-md-end d-flex flex-column flex-md-row">
                                            <AppSearchBox
                                                searchTerm={searchTerm}
                                                setSearchTerm={setSearchTerm}
                                                setSearchTermCompleted={setSearchTermCompleted}
                                            />
                                            <button className="text-nowrap btn btn-red btn-sm ms-md-3 fw-semibold f-s-14" type="button" onClick={handleAddClick}>
                                                <i className="ph-bold  ph-circles-three-plus"></i> Add Party
                                            </button>
                                            {/* <PartiesReport reportLoading={reportLoading} setReportLoading={setReportLoading} /> */}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="content-wrapper" id="card-container">
                                <div className="d-flex flex-wrap m-md-3">
                                    {partiesList.data.length > 0 ? (
                                        <>
                                            <AppPaginator
                                                entityName={entityName}
                                                currentPage={partiesList.current_page} // Use current_page from state
                                                totalPages={partiesList.tot_page}
                                                setCurrentPage={setCurrentPage}
                                            />
                                            <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                                            <div className='d-flex align-items-center ms-auto mt-2 mt-md-0'>
                                                <button className="btn btn-info btn-sm me-2" type="button" onClick={() => setEnableMultipleItemSelect(prevState => !prevState)}>
                                                    {enableMultipleItemSelect ? (<><i className="fa-solid fa-check fa-fw me-1" />Done</>) : 'Select'}
                                                </button>
                                                {enableMultipleItemSelect && selectedPartyIds.size > 0 && (
                                                    <button className="btn btn-danger btn-sm" type="button" onClick={showMultipleDeleteConfirmation}>
                                                        Delete ({selectedPartyIds.size}) Records
                                                    </button>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        !viewDataLoading && <p className="text-center w-100">No parties found.</p> // Show message only when not loading
                                    )}
                                    {(reportLoading || viewDataLoading) && (
                                        <div className="loader_box ms-auto">
                                            <div className="loader_14"></div>
                                        </div>
                                    )}
                                </div>

                                <div className="tabs-content active" id="tab-1">
                                    <div className="row">
                                        {!viewDataLoading && partiesList.data.map((party) => (
                                            <div className="col-md-6 col-xl-4 project-card" key={party.id}>
                                                <div className="card hover-effect" id={`card-${party.id}`}>
                                                    <div className="card-header">
                                                        <div className="d-flex align-items-center">
                                                            {enableMultipleItemSelect && (
                                                                <input
                                                                    className="form-check-input me-2"
                                                                    type="checkbox"
                                                                    checked={selectedPartyIds.has(party.id)}
                                                                    onChange={(e) => handleCheckboxChange(party.id, e.target.checked)}
                                                                    id={`select-party-${party.id}`}
                                                                />
                                                            )}
                                                             {/* Replace avatar logic if needed */}
                                                            <div className="h-40 w-40 d-flex-center b-r-50 overflow-hidden me-2 btn-light-reddit">
                                                                <i className="ti ti-users f-s-18"></i> {/* Generic icon */}
                                                            </div>
                                                            <a className="flex-grow-1 ps-2" href="#"> {/* Removed link for simplicity */}
                                                                <h6 className="m-0 text-dark f-w-600">{party.name}</h6>
                                                                {party.code && <small className="text-muted">Code: {party.code}</small>}
                                                            </a>
                                                            <div className="dropdown">
                                                                <button aria-expanded="false" className="bg-none border-0" data-bs-toggle="dropdown" type="button">
                                                                    <i className="ti ti-dots-vertical text-dark" />
                                                                </button>
                                                                <ul className="dropdown-menu dropdown-menu-end">
                                                                    <li>
                                                                        <a className="dropdown-item" onClick={() => handleEditClick(party.id)}>
                                                                            <i className="ti ti-edit text-success me-1" /> Edit
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a className="dropdown-item delete-button" onClick={() => handleDeleteClick(party.id)}>
                                                                            <i className="ti ti-trash text-danger me-1" /> Delete
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-7">
                                                                {party.partygroup && <h6 className="text-dark f-s-14">Group: <span className="text-primary">{party.partygroup.name}</span></h6>}
                                                                {party.phone_number && <h6 className="text-dark f-s-14">Phone: <span className="text-muted">{party.phone_number}</span></h6>}
                                                                {party.email && <h6 className="text-dark f-s-14">Email: <span className="text-muted">{party.email}</span></h6>}
                                                            </div>
                                                            <div className="col-5 text-end">
                                                                <p className="f-w-500 text-secondary mb-1">ID</p>
                                                                <h6 className="f-w-600">{party.id}</h6>
                                                            </div>
                                                        </div>
                                                         {/* Optionally display default address snippet */}
                                                         {party.addresses && party.addresses.length > 0 && (
                                                             <div className="mt-2 pt-2 border-top">
                                                                 <small className="text-muted">
                                                                     Default Addr: {party.addresses.find(a=>a.is_default_billing)?.address_line_1 || party.addresses[0].address_line_1}
                                                                 </small>
                                                             </div>
                                                         )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {/* No Data Card */}
                                        {!viewDataLoading && partiesList.data.length === 0 && (
                                            <div className="col-12">
                                                 <div className="card mb-3">
                                                    <div className="row g-0">
                                                        <div className="col-md-6 col-xl-8">
                                                            <div className="card-body">
                                                            <h5 className="card-title">No Parties Found</h5>
                                                            <p className="card-text">No records found matching your search criteria or no parties have been added yet.</p>
                                                            </div>
                                                        </div>
                                                        {/* Optional image */}
                                                        {/* <div className="col-md-6 col-xl-4"><img alt="..." className="img-fluid" src="../assets/images/..." /></div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default PartiesPage;